export default __webpack_public_path__ + "static/media/dc-black.3747c663.jpg";